import * as React from "react"
import { cn } from "@/lib/utils"

// The one mark for "this is AI" across the app. Drop-in for lucide icons:
// sized/colored via className (currentColor), or variant="gradient".
const AiIcon = React.forwardRef(({ className, variant = "solid", size, strokeWidth, ...props }, ref) => {
  const gid = React.useId()
  const fill = variant === "gradient" ? `url(#${gid})` : "currentColor"
  return (
    <svg
      ref={ref}
      viewBox="0 0 24 24"
      width={size ?? 24}
      height={size ?? 24}
      aria-hidden={props["aria-label"] ? undefined : true}
      className={cn("lucide shrink-0", className)}
      {...props}
    >
      {variant === "gradient" && (
        <defs>
          <linearGradient id={gid} x1="2" y1="2" x2="22" y2="22" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#6366F1" />
            <stop offset="0.55" stopColor="#8B5CF6" />
            <stop offset="1" stopColor="#EC4899" />
          </linearGradient>
        </defs>
      )}
      <path fill={fill} d="M10 3.5c.55 4.6 2.9 6.95 7.5 7.5v.9c-4.6.55-6.95 2.9-7.5 7.5h-.9c-.55-4.6-2.9-6.95-7.5-7.5V11c4.6-.55 6.95-2.9 7.5-7.5h.9Z" />
      <path fill={fill} opacity={variant === "gradient" ? 1 : 0.7} d="M19.2 1.5c.22 1.86 1.17 2.8 3.03 3.03v.44c-1.86.22-2.8 1.17-3.03 3.03h-.44c-.22-1.86-1.17-2.8-3.03-3.03v-.44c1.86-.22 2.8-1.17 3.03-3.03h.44Z" />
    </svg>
  )
})
AiIcon.displayName = "AiIcon"

export { AiIcon }
